/* ============================================================
   ANJUS — Collection folio interactions (reveal + filter)
   ============================================================ */
(function () {
  'use strict';
  var folio = document.querySelector('.folio');
  if (folio) {
    // Collection-name styling: the "1958" in "Marigold 1958" reads italic
    // (display font) wherever the collection name appears in the folio prose.
    folio.querySelectorAll('.f-lead, .f-body').forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/Marigold(\s|&nbsp;)1958/g, 'Marigold$1<em class="yr-italic">1958</em>');
    });

    var rises = folio.querySelectorAll('[data-rise]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      rises.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      folio.classList.add('ready');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      rises.forEach(function (el) { io.observe(el); });
    }
  }

  var bar = document.querySelector('.filter-bar');
  if (bar) {
    var pieces = Array.prototype.slice.call(document.querySelectorAll('.grid .piece'));
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.filter-btn');
      if (!btn) return;
      var f = btn.getAttribute('data-filter');
      bar.querySelectorAll('.filter-btn').forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      pieces.forEach(function (p) {
        var stones = ' ' + (p.getAttribute('data-stones') || '') + ' ';
        var match = f === 'all' || p.getAttribute('data-type') === f || stones.indexOf(' ' + f + ' ') !== -1;
        p.style.display = match ? '' : 'none';
      });
    });
  }
})();